module.exports = __webpack_public_path__ + "static/media/cts-poster.c80a15bf.jpg";